<!--
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-06-06 17:50:27
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-06-14 19:34:56
 * @FilePath: /jy-dashboard-web/src/components/companyProfile/component-gsxw.vue
 * @Description: 公司新闻
-->
<template>
  <div class="gsxw">
    <div class="content" v-loading="loading.gsxw">
      <el-carousel
        height="200px"
        direction="vertical"
        :autoplay="true"
        v-if="!loading.gsxw"
      >
        <el-carousel-item v-for="(item, index) in gsxw" :key="index">
          <el-image :src="item.xwnr" />
          <h3 text="2xl" justify="center">{{ item.xwmc }}</h3>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  computed: {
    ...mapState('company-profile', ['loading', 'gsxw'])
  },
  methods: {
    ...mapActions('company-profile', ['getGSXW', 'getXWXQ'])
  },
  created () {
    this.getGSXW()
  }
}
</script>

<style lang="scss">
.gsxw {
  padding-top: 52px;
  .content {
    height: 100%;
    position: relative;
    padding-top: 4px;
    .el-carousel {
      .el-carousel__container {
        height: 173px !important;
        width: 275px;
        margin: 0 auto;
        .el-carousel__item {
          // &:nth-child(2n) {
          //   background-color: #99a9bf;
          // }
          // &:nth-child(n) {
          //   background-color: #596575;
          // }
          h3 {
            position: absolute;
            bottom: 10px;
            left: 0;
            width: 100%;
            margin: 0;
            text-align: center;
            background-color: rgba(8, 26, 36, 0.54);
            color: #fcffff;
          }
        }
      }
    }
  }
}
</style>
